export function updateWithEditorPlaceholder(dom: HTMLElement) {
  dom.classList.add('fteditor-editor-placeholder')
}
